var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import RcImage from 'rc-image';
import React, { useContext } from 'react';
import { OutlinedEye } from 'acud-icon';
import { ConfigContext } from '../config-provider';
import defaultLocale from '../locale/default';
import { getTransitionName } from '../_util/motion';
import PreviewGroup, { icons } from './PreviewGroup';
const Image = (_a) => {
    var { prefixCls: customizePrefixCls, preview } = _a, otherProps = __rest(_a, ["prefixCls", "preview"]);
    const { getPrefixCls, locale: contextLocale = defaultLocale, getPopupContainer: getContextPopupContainer } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('image', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const imageLocale = contextLocale.Image || defaultLocale.Image;
    const mergedPreview = React.useMemo(() => {
        if (preview === false) {
            return preview;
        }
        const realPreview = typeof preview === 'object' ? preview : {};
        const { getContainer } = realPreview, restPreviewProps = __rest(realPreview, ["getContainer"]);
        return Object.assign(Object.assign({ mask: (<div className={`${prefixCls}-mask-info`}>
                    <OutlinedEye />
                    {imageLocale === null || imageLocale === void 0 ? void 0 : imageLocale.preview}
                </div>), icons }, restPreviewProps), { 
            // 这里的 as typeof getContainer 仅仅是为了类型推断，实际并不会影响逻辑
            getContainer: getContainer || getContextPopupContainer, transitionName: getTransitionName(rootPrefixCls, 'zoom', realPreview.transitionName), maskTransitionName: getTransitionName(rootPrefixCls, 'fade', realPreview.maskTransitionName) });
    }, [preview, prefixCls, imageLocale === null || imageLocale === void 0 ? void 0 : imageLocale.preview, getContextPopupContainer, rootPrefixCls]);
    return <RcImage prefixCls={prefixCls} preview={mergedPreview} {...otherProps}/>;
};
Image.PreviewGroup = PreviewGroup;
export default Image;
